import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface EligibilityStore {
  // Eligibility form state
  eligibilityStatus: string | null
  eligibilityData: any
  copay: number | null
  policyMetadata: any
  policyRetryCount: number | null
  selectedPayer: any
  eligibilityInputParams: {
    payerId: string | null
    memberId: string | null
    skipMembershipId: boolean | null
    state: string | null
    firstName: string | null
    lastName: string | null
    dateOfBirth: string | null
    diagnoses: string[]
  } | null
  latestEligibilityParamsFromDB: any | null

  // Actions
  setEligibilityStatus: (status: string | null) => void
  setEligibilityData: (data: any) => void
  setCopay: (copay: number | null) => void
  setPolicyMetadata: (metadata: any) => void
  setPolicyRetryCount: (count: number | null) => void
  setSelectedPayer: (payer: any) => void
  setEligibilityInputParams: (
    params: {
      payerId: string | null
      memberId: string | null
      skipMembershipId: boolean | null
      state: string | null
      firstName: string | null
      lastName: string | null
      dateOfBirth: string | null
      diagnoses: string[]
    } | null
  ) => void
  setLatestEligibilityParamsFromDB: (params: any | null) => void
  reset: () => void
}

export const useEligibilityStore = create<EligibilityStore>()(
  devtools(
    (set, get) => ({
      // Initial state
      eligibilityStatus: null,
      eligibilityData: null,
      copay: null,
      policyMetadata: null,
      policyRetryCount: null,
      selectedPayer: null,
      eligibilityInputParams: null,
      latestEligibilityParamsFromDB: null,

      // Set eligibility status
      setEligibilityStatus: status =>
        set(
          { eligibilityStatus: status },
          false,
          `setEligibilityStatus: ${status}`
        ),

      // Set eligibility data
      setEligibilityData: data =>
        set({ eligibilityData: data }, false, 'setEligibilityData'),

      // Set copay
      setCopay: copayValue =>
        set({ copay: copayValue }, false, `setCopay: ${copayValue}`),

      // Set policy metadata
      setPolicyMetadata: metadata =>
        set({ policyMetadata: metadata }, false, 'setPolicyMetadata'),

      // Set policy retry count
      setPolicyRetryCount: count =>
        set(
          { policyRetryCount: count },
          false,
          `setPolicyRetryCount: ${count}`
        ),

      // Set selected payer
      setSelectedPayer: payer =>
        set({ selectedPayer: payer }, false, 'setSelectedPayer'),

      // Set eligibility input params
      setEligibilityInputParams: params =>
        set(
          { eligibilityInputParams: params },
          false,
          'setEligibilityInputParams'
        ),

      // Set latest eligibility params from database
      setLatestEligibilityParamsFromDB: params =>
        set(
          { latestEligibilityParamsFromDB: params },
          false,
          'setLatestEligibilityParamsFromDB'
        ),

      // Reset all eligibility state
      reset: () =>
        set(
          {
            eligibilityStatus: null,
            eligibilityData: null,
            copay: null,
            policyMetadata: null,
            policyRetryCount: null,
            selectedPayer: null,
            eligibilityInputParams: null,
            latestEligibilityParamsFromDB: null,
          },
          false,
          'reset'
        ),
    }),
    { name: 'EligibilityStore' }
  )
)
